export enum ColorPresetNames {
  Default = 'default',
  Purple = 'purple',
  Cyan = 'cyan',
  Blue = 'blue',
  Orange = 'orange',
  Red = 'red',
}

export enum ThemeMode {
  Light = 'light',
  Dark = 'dark',
}

export enum ThemeDirection {
  LTR = 'ltr',
  RTL = 'rtl',
}

export enum ThemeLayout {
  Vertical = 'vertical',
  Horizontal = 'horizontal',
}
